import $http from '../../shared/http';

export default {
  namespaced: true,
  state: () => {
    return {
      branchManagementRequest: null,
      isBranchManagementChurchesView: false,
    };
  },
  getters: {
    getBranchManagementRequest: (state) => state.branchManagementRequest,
    BRANCH_MANAGEMENT_NOT_REQUESTED: (state, getters) =>
      getters.getBranchManagementRequest === false,
    GLOBAL_ADMIN_APPROVAL_PENDING: (state, getters) => {
      return typeof getters.getBranchManagementRequest !== 'boolean'
        ? getters.getBranchManagementRequest?.isApprovedByGlobalAdmin === false
        : true;
    },
    DENOMINATION_ADMIN_APPROVAL_PENDING: (state, getters) => {
      return typeof getters.getBranchManagementRequest !== 'boolean'
        ? getters.getBranchManagementRequest?.isApprovedByDenominationAdmin === false
        : true;
    },
    IS_BRANCH_MANAGEMENT_ACCESS_FULLY_APPROVED: (state, getters, rootState, rootGetters) => {
      if (rootGetters['auth/isGlobalUser']) {
        return true;
      }
      return !getters.DENOMINATION_ADMIN_APPROVAL_PENDING && !getters.GLOBAL_ADMIN_APPROVAL_PENDING;
    },
    IS_BRANCH_MANAGEMENT_CHURCHES_VIEW: (state) => state.isBranchManagementChurchesView,
  },
  mutations: {
    setBranchManagementRequest: (state, payload) => (state.branchManagementRequest = payload),
    setBranchManagementChurchesView: (state, payload) =>
      (state.isBranchManagementChurchesView = payload),
  },
  actions: {
    async LOAD_BRANCH_MANAGEMENT_REQUEST({ commit }, orgId) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .get(`/branch-management-requests/${orgId}`)
          .then(async (response) => {
            commit('setBranchManagementRequest', response.data.data);
            return resolve(response.data.data);
          })
          .catch((error) => {
            return reject(error?.response ?? error);
          });
      });
    },

    async REQUEST_BRANCH_MANAGEMENT(/* ctx */) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .post('/branch-management-requests', undefined, { headers: { 'X-Is-Notifiable': 'On' } })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async APPROVE_BRANCH_MANAGEMENT_REQUEST(ctx, orgId) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .patch(`/branch-management-requests/${orgId}`)
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },

    async DELETE_BRANCH_MANAGEMENT_REQUEST(ctx, orgId) {
      return new Promise(async (resolve, reject) => {
        await $http()
          .delete(`/branch-management-requests/${orgId}`, undefined, {
            headers: { 'X-Is-Notifiable': 'On' },
          })
          .then(async (response) => {
            return resolve(response);
          })
          .catch((error) => {
            reject(error?.response ?? error);
          });
      });
    },
  },
};
